export default {
  CAMPAIGNS_FETCHED: 'CAMPAIGNS_FETCHED',
  CAMPAIGNS_LOAD: 'CAMPAIGNS_LOAD',
};
